export default "__VITE_ASSET__CNoW76nF__"